import React from 'react';
import moment from 'moment';
import Checkbox from '../../../webcommon/common/checkbox/Checkbox';
import WithTooltip from '../../../webcommon/common/formcomponents/customvalidation/ComponentWithTooltip';
import WebJobsStatus from './customgridcomponents/Status';
import Message from './customgridcomponents/Message';
import * as appConstants from '../../../common/constants';

const MessageWithTooltip = WithTooltip(Message);

const textWithLineBreaks = (text) => {
    if (!text) { return ''; }
    if (text.search('<br>') !== -1) {
        const splitText = text.split('<br>');
        const lastIndex = splitText.length - 1;
        return splitText.map(
            (val, i) => (
                <>
                    {val}
                    { i === lastIndex ? null : <br />}
                </>
            )
        );
    }
    return text;
};

const mappings = [
    {
        id: 'checkbox',
        title: '',
        width: 40,
        filterable: false,
        renderCell: row => (
            <Checkbox
                checked={ row.original.selected }
                onChange={ (checked) => {
                    row.column.getGridProps().setRowChecked(row.original.requestId, checked);
                } }
            />
        ),
        Header: header => (
            <Checkbox
                checked={ header.column.getGridProps().headerChecked }
                onChange={ (checked) => {
                    header.column.getGridProps().setHeaderChecked(checked);
                } }
            />
        )
    },
    {
        id: 'source',
        title: 'Source'
    },
    {
        id: 'category',
        title: 'Category'
    },
    {
        id: 'businessDate',
        title: 'Date',
        filterMethod: (filter, row) => moment(row.businessDate).format(appConstants.dateFormat).includes(filter.value),
        renderCell: row => moment(row.original.businessDate).format(appConstants.dateFormat) || ''
    },
    {
        id: 'timestamp',
        title: 'Timestamp',
        filterMethod: (filter, row) => moment(row.timestamp).format(appConstants.dateTimeFormat).includes(filter.value),
        renderCell: row => moment(row.original.timestamp).format(appConstants.dateTimeFormat) || ''
    },
    {
        id: 'errorMessage',
        title: 'Message',
        renderCell: row => <MessageWithTooltip value={ row.value } tooltipMessage={ textWithLineBreaks(row.value) } placement="top" showTooltip />
    },
    {
        id: 'status',
        title: 'Status',
        renderCell: row => (
            <WebJobsStatus
                id={ row.original.requestId }
                rerunSelectedRow={ row.column.getGridProps().rerunSelectedRow }
                showIcons
                setDetailsBeingViewed={ (row.column.getGridProps().setDetailsBeingViewed) }
                status={ row.value }
            />
        )
    }
];

export default mappings;
